import React from 'react'

interface IssueLinkingNoteProps {
  issueName: string
}

export const IssueLinkingNote: React.FC<IssueLinkingNoteProps> = ({ issueName }) => (
  <div className='write-message-issue-linking-note' role='status'>
    <i className='fa-kit fa-pro-comment-exclamation' aria-hidden='true' />
    <div className='write-message-issue-linking-note__text'>
      <strong>This conversation will be linked to Active Issue: {issueName}.</strong>
      {' '}
      Message recipients will be notified that they have been added to an active issue.
    </div>
  </div>
)
